import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin, Twitter, Instagram, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] border-t border-white/10 pt-16 pb-8" data-id="element-47" data-mp="32o4deh7i4k9p">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-48" data-mp="32m1bozwzl2p5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-49" data-mp="36qhfmvn1i01q">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-50" data-mp="3ufjuxwu7bgt2">
            <img src="https://cdn.magicpatterns.com/uploads/dpR9DXwCEF7xE6YLwrKxu9/1-offical-logo.png" alt="Sinclair Development" className="h-20 w-auto border-2 border-white rounded-sm" data-id="element-51" data-mp="38qtqszerhoj" />
            <p className="text-white font-serif text-xl" data-id="element-52" data-mp="3qc41189inuk2">Sinclair Develops.</p>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-53" data-mp="29yxehh44xsnx">
              We identify opportunities and bring together the planning, design,
              construction and management necessary to turn them into successful
              properties throughout Southwest Florida.
            </p>
            <a href="https://sinclairdevelops.com" className="inline-block text-[#C5A55A] text-sm tracking-[0.15em] uppercase hover:text-[#D4AF37] transition-colors" data-id="element-54" data-mp="3gb8vj0znlauj">
              SinclairDevelops.com
            </a>
          </div>

          {/* Quick Links */}
          <div data-id="element-55" data-mp="828mc4dy418m">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-56" data-mp="81pexhlx8v8u">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-57" data-mp="33e4b4nsygpk">
              {['Home', 'About', 'Services', 'Contact'].map(item => <li key={item} data-id="element-58" data-mp="huwicwx3q16a">
                  <Link to={item === 'Home' ? '/' : `/${item.toLowerCase()}`} className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-59" data-mp="cu0h6r44wt4k">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-60" data-mp="twxuhinrnqdj">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-61" data-mp="tt0ayvxa0wt4">
              What We Develop
            </h3>
            <ul className="space-y-3" data-id="element-62" data-mp="13tao6gjba48a">
              <li className="text-gray-400 text-sm" data-id="element-63" data-mp="13s99m2336zlt">Site Development</li>
              <li className="text-gray-400 text-sm" data-id="element-64" data-mp="18jr3652s5xwr">Commercial Development</li>
              <li className="text-gray-400 text-sm" data-id="element-65" data-mp="18ltx30720b6r">Residential Development</li>
              <li className="text-gray-400 text-sm" data-id="element-66" data-mp="1cnozk80q0um4">Redevelopment</li>
              <li className="text-gray-400 text-sm" data-id="element-67" data-mp="1hje30mfv2vnp">Tenant Improvements</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-68" data-mp="1mhxpqp2a4bh4">
            <h3 className="text-[#C5A55A] font-serif text-lg mb-6" data-id="element-69" data-mp="1riv9h62xtdkq">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-70" data-mp="3obomle3mrfgi">
              <li className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-71" data-mp="3ocpytlwdu7zt">
                <MapPin className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-72" data-mp="3t9gguerqzdnv" />
                <a href="https://www.google.com/maps/search/?api=1&query=329+NE+3rd+Ave+Cape+Coral+FL+33909" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-73" data-mp="2aevdxsrcbo5s">
                  329 NE 3rd Ave
                  <br data-id="element-74" data-mp="1woi6rsm9wdhi" />
                  Cape Coral, FL 33909
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-75" data-mp="2te9e4sfnxv4q">
                <Phone className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-76" data-mp="2pcnsahl5i6ie" />
                <a href="tel:239-810-9482" className="hover:text-white transition-colors" data-id="element-77" data-mp="2pa9yec27j0cf">
                  239-810-9482
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" data-id="element-78" data-mp="2fgkol7anhztc">
                <Mail className="w-5 h-5 text-[#C5A55A] shrink-0" data-id="element-79" data-mp="18zfs8tmxr0r8" />
                <a href="mailto:info@sinclairdevelops.com" className="hover:text-white transition-colors" data-id="element-80" data-mp="13y04gttdig55">
                  info@sinclairdevelops.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-81" data-mp="2iwmaed3dl35a">
          <p className="text-gray-500 text-xs text-center md:text-left" data-id="element-82" data-mp="2nue4ndrht1cn">
            © {new Date().getFullYear()} Sinclair Development. All rights
            reserved.
            <span className="mx-2 text-white/20" data-id="element-83" data-mp="3fk0ow4pgyq0o">|</span>
            <span className="text-[#C5A55A] tracking-wider" data-id="element-84" data-mp="31lj2cabavjkc">
              FL License #CGC1541661
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-85" data-mp="36juckm5ibw33">
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-86" data-mp="36mgloq81qjnf">
              <Facebook className="w-4 h-4" data-id="element-87" data-mp="1v604arcxlsxx" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-88" data-mp="1v3dyaw5ovlht">
              <Twitter className="w-4 h-4" data-id="element-89" data-mp="1ine6wa1tih4p" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-90" data-mp="1ioz281vyi43m">
              <Linkedin className="w-4 h-4" data-id="element-91" data-mp="1rnsuxh662abw" />
            </a>
            <a href="#" className="text-gray-500 hover:text-[#C5A55A] transition-colors" data-id="element-92" data-mp="1roca4q4fmkm8">
              <Instagram className="w-4 h-4" data-id="element-93" data-mp="zwn1fjkybavl" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}